module.exports = __webpack_public_path__ + "static/menu-food-fa91d935b911900f86b4e3472c4f1fd9.png";